import Controller from '@ember/controller';
import { action } from '@ember/object';
import SetupGuide from 'cio/models/setup-guide';
import { MessagingChannelType, PresentationLocation } from 'cio/utils/setup-guide/messaging-channels';

export default class SetupGuideChannelsInAppController extends Controller {
  model!: SetupGuide;

  presentationLocation = PresentationLocation;

  @action
  markInAppComplete() {
    return this.model.markChannelComplete(MessagingChannelType.InApp);
  }
}
